<template>
    <div class="bg-gray-moblyFA p-4 md:p-6 flex items-center rounded-lg">
        <div class="w-16 h-16 md:w-32 md:h-32 flex-shrink-0">
            <img class="w-full h-full object-contain"
                 :src="item.image"
                 :alt="item.orderNr">
        </div>
        <div class="ml-4 md:ml-6 flex-grow">
            <div class="text-gray-mobly54 font-semibold text-base md:text-xl">
                Pedido: {{ item.orderNr }}
            </div>
            <div class="text-gray-mobly54 text-xs font-normal md:text-sm mt-1">
                Data de compra: <span class="font-semibold">{{ item.date }}</span>
            </div>
            <div class="text-gray-mobly54 text-xs font-normal md:text-sm">
                Valor: <span class="font-semibold">R$ {{ item.grandTotal }}</span>
            </div>
            <div class="text-gray-mobly54 text-xs font-normal md:text-sm">
                Compra efetuada em:
                <span v-if="item.marketplace !== null" class="font-semibold">{{ item.marketplace }}</span>
                <span v-else class="font-semibold">Mobly</span>
            </div>
            <div v-if="item.paymentMethod !== '' && item.paymentMethod !== null" class="text-gray-mobly54 text-xs font-normal md:text-sm">
                Forma de pagamento: <span class="font-semibold">{{ item.paymentMethod }}</span>
            </div>
            <div v-if="item.couponCode" class="text-gray-mobly54 text-xs font-normal md:text-sm">
                Cupom: <span class="font-semibold">{{ item.couponCode }}</span>
            </div>
            <div class="text-gray-mobly54 font-normal text-sm md:text-lg">
                {{ itemsCountLabel }}
            </div>
        </div>
            <div v-show="item.covid" class="w-full col-span-3 px-1 md:col-span-1">
                <CovidList />
            </div>
    </div>

</template>

<script>
import namespace from '../../vuex/namespace'
import { mapState } from 'vuex'
import CovidList from '../Covid/CovidList'

export default {
  name: 'OrderBox',
  props: ['itemList'],
  components: {
    CovidList
  },
  computed: {
    ...mapState(namespace.ORDERS, [
      'list'
    ]),
    mountRouteWithParam: function () {
      return {
        path: `meus-pedidos/pedido/${this.item.orderNr}`
      }
    },
    itemsCountLabel: function () {
      const count = this.item.itemsCount
      return count + (count === 1 ? ' item' : ' itens')
    },
    item: function () {
      return this.itemList
    }
  }
}
</script>
